import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import text_logo from '../assets/quokka_logo_green.png'; // Adjust the path based on your image location
import '../App.css';

const Header = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    
    // Prevent body scrolling when menu is open
    useEffect(() => {
        if (mobileMenuOpen) {
            document.body.classList.add('menu-open');
        } else {
            document.body.classList.remove('menu-open');
        }
        
        // Cleanup function
        return () => {
            document.body.classList.remove('menu-open');
        };
    }, [mobileMenuOpen]);
    
    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };
    
    return (
        <header className={`header ${mobileMenuOpen ? 'mobile-menu-active' : ''}`}>
            <div className="header-content">
                <Link to="/" className="logo-container">
                    <img src={text_logo} alt="Quokka Logo" className="text_logo" />
                </Link>
                
                <button 
                    className="mobile-menu-button"
                    onClick={toggleMobileMenu}
                    aria-label="Toggle menu"
                >
                    <span className="menu-icon"></span>
                </button>
                
                <nav className="nav-links">
                    <Link to="/for-companies" onClick={() => setMobileMenuOpen(false)}>FOR COMPANIES</Link>
                    <Link to="/for-candidates" onClick={() => setMobileMenuOpen(false)}>FOR CANDIDATES</Link>
                    {/* <Link to="/enterprise">MANIFESTO</Link> */}
                    <Link to="/about-us" onClick={() => setMobileMenuOpen(false)}>OUR TEAM</Link>
                    <Link to="/FAQ" onClick={() => setMobileMenuOpen(false)}>FAQ</Link>
                    <Link to="/private" style={{display: 'none'}} onClick={() => setMobileMenuOpen(false)}>PRIVATE</Link>
                    {/* <Link to="/schedule-demo"> */}
                        <button 
                            className="cta-button" 
                            onClick={() => {
                                window.open('https://meetings.hubspot.com/david4497', '_blank');
                                setMobileMenuOpen(false);
                            }}
                        >
                            Schedule Demo
                        </button>
                    {/* </Link> */}
                </nav>
            </div>
        </header>
    );
};

export default Header;

